import { render, staticRenderFns } from "./PressRelease.vue?vue&type=template&id=6a2f898a&scoped=true&"
import script from "./PressRelease.vue?vue&type=script&lang=js&"
export * from "./PressRelease.vue?vue&type=script&lang=js&"
import style0 from "./PressRelease.vue?vue&type=style&index=0&id=6a2f898a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f898a",
  null
  
)

export default component.exports